<template>
    <b-modal
        :id="'update-section' + sectionIn.id"
        :title="$t('rubrics.edit_rubric')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        @ok="onOk"
        @show="onShow"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal">
        <div class="rubric-edit">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    v-if="error.error"
                    v-for="(error, index) in errors"
                    variant="danger"
                    show
                    :key="index">
                    {{ error.message }}
                </b-alert>
            </div>

            <b-form-group
                class="rubric-title-group"
                :label="$t('common.title')"
                label-for="rubric-title-input"
                :invalidFeedback="invalidFeedback"
                :state="state">
                <b-form-input
                    id="rubric-title-input"
                    v-model="title"
                    :placeholder="$t('common.title')"></b-form-input>
            </b-form-group>

            <b-form-group
                class="rubric-weight-group"
                v-if="showValues"
                :label="$t('rubrics.value')"
                label-for="rubric-weight-input">
                <b-form-input
                    id="rubric-weight-input"
                    v-model="weight"
                    :placeholder="$t('rubrics.value')"></b-form-input>
            </b-form-group>

            <b-form-group
                class="rubric-order-group"
                :label="$t('rubrics.position')"
                label-for="rubric-order-input">
                <b-form-select
                    class="apprentice-primary-select"
                    id="rubric-order-input"
                    v-model="order"
                    :options="getOrdersList"
                    :placeholder="$t('rubrics.order')"></b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-update-rubric-section-modal-component',
    props: {
        sectionIn: Object,
        showValues: Number,
        rubricSections: Array,
    },
    data() {
        return {
            title: this.sectionIn.title,
            weight: this.sectionIn.weight,
            order: this.sectionIn.order,
            hasError: false,
            errors: {
                title: {
                    error: false,
                    message: this.$t('rubrics.the_title_field_cannot_be_empty'),
                },
                weight: {
                    error: false,
                    message: this.$t('rubrics.the_field_value_does_not_contain_a_valid_number'),
                },
            },
        };
    },
    methods: {
        onOk(bvModalEvt) {
            this.checkForErrors();
            if (this.hasError) {
                bvModalEvt.preventDefault();
                return;
            }

            const data = {
                id: this.sectionIn.id,
                title: this.title,
                weight: this.weight,
                order: this.order,
                show_values: this.showValues,
            };

            this.alert.saving();
            this.axios.post(this.routes.updateRubricSection(this.sectionIn.id), data).then(
                (response) => {
                    this.sectionIn.update(response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.title = this.sectionIn.title;
            this.weight = this.sectionIn.weight;
            this.order = this.sectionIn.order;
            this.error = false;
        },

        checkForErrors() {
            this.hasError = false;
            if (this.title === '') {
                this.hasError = true;
                this.errors.title.error = true;
            }

            if (isNaN(this.weight)) {
                this.hasError = true;
                this.errors.value.error = true;
            }
        },
    },

    computed: {
        getOrdersList() {
            let sections = [];
            if (this.rubricSections.length) {
                sections = this.rubricSections.map((section) => {
                    return {
                        value: section.order,
                        text: section.order,
                        disabled: section.order === this.order,
                    };
                });
                sections.sort((a, b) => (a.value > b.value ? 1 : -1));
            }

            return sections;
        },

        invalidFeedback() {
            if (this.title !== '' && this.title.length > 40) {
                const charsExceed = this.title.length - 40;
                return this.$tc('rubrics.you_have_x_characters_too_much_max_y', charsExceed, { max: 40 });
            }

            return this.$t('rubrics.the_tile_cannot_be_longer_than_x_characters', { max: 40 });
        },

        state() {
            return this.title !== '' && this.title.length <= 40 && this.title.length > 0;
        },
    },
};
</script>

<style scoped lang="scss">
.errors {
    flex: 1 0 100%;
}

.rubric-edit > label {
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'five');
}

.rubric-edit .form-group {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.rubric-title-group > input {
    padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'fifteen');
}

.rubric-weight-group > input,
.rubric-order-group > input {
    padding: map-get($grid-gutter-spacing, 'eight');
}

@media (min-width: 576px) {
    .rubric-edit {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .rubric-title-group {
        flex: 1 0 50%;
    }

    .rubric-weight-group,
    .rubric-order-group {
        flex: 1 0 10%;
    }

    .rubric-weight-group {
        margin-left: map-get($grid-gutter-spacing, 'twenty-one');
        margin-right: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .rubric-title-group + .rubric-order-group {
        margin-left: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .rubric-order-group > select {
        height: 35px;
    }
}
</style>
